import axiosIns from '@axios'

const getHolidaysService = async ({ searchInput, date, status, type, page, limit, filterType, userFilter }) => {
    return axiosIns.get(`/custom`, { params: { company: 'olx,clicar,wigo', isAllDay:status, page, limit }})
}

const getHolidayByIdService = async ({ holidayId }) => {
    return await axiosIns.get(`/custom/${holidayId}`)
}

const updateHolidayService = async ({ holidayId, updatedHoliday}) => {
    return await axiosIns.patch(`/custom/${holidayId}`, updatedHoliday)
}

const createHolidayService = async ({ updatedHoliday}) => {
    return await axiosIns.post(`/custom`, updatedHoliday)
}

const deleteHolidayService = async (holidayId) => {
    return await axiosIns.delete(`/custom/${holidayId}`)
}

export {
    getHolidaysService,
    updateHolidayService,
    getHolidayByIdService,
    createHolidayService,
    deleteHolidayService
}